import { Accordion, AccordionDetails } from '@mui/material';
import React, { useCallback } from 'react';
import type { FilterField, FilterSection } from '../../../api/models/filters.model';
import FilterFieldAccordion from './FilterFieldAccordion';
import AccordionSummary from './StyledSectionAccordionSummary';

interface FilterSectionAccordionProps {
	section: FilterSection;
	pendingFilterValues: { [key: string]: any };
	handleFieldChange: (field: FilterField, value: any) => void;
	findAFilterValue: string;
}

const FilterSectionAccordion: React.FC<FilterSectionAccordionProps> = ({
	section,
	pendingFilterValues,
	handleFieldChange,
	findAFilterValue,
}) => {
	const [filterExpanded, setFilterExpanded] = React.useState<boolean>(false);

	const shouldBeExpanded = useCallback(
		(findAFilterValue: string, filterExpanded: boolean) => {
			if (filterExpanded) {
				return true;
			}
			return findAFilterValue.length > 0;
		},
		[findAFilterValue, filterExpanded]
	);

	const sectionVisibleFields = React.useMemo(
		() =>
			section.fields.filter((field) => {
				return (
					findAFilterValue.length === 0 ||
					field.label.toLowerCase().includes(findAFilterValue.toLowerCase()) ||
					section.label.toLowerCase().includes(findAFilterValue.toLowerCase())
				);
			}),
		[section.fields, findAFilterValue, section.name]
	);

	return sectionVisibleFields.length > 0 ? (
		<Accordion
			key={section.name}
			expanded={shouldBeExpanded(findAFilterValue, filterExpanded)}
			onChange={() => setFilterExpanded((prev) => !prev)}
			data-testid={`filter-accordion-section-${section.name}`}
			sx={{
				'&::before': {
					display: 'none', // removes the horizontal border
				},
			}}
		>
			<AccordionSummary>{section.label}</AccordionSummary>
			<AccordionDetails>
				{sectionVisibleFields.map((field) => (
					<FilterFieldAccordion
						key={field.name}
						field={field}
						pendingFilterValues={pendingFilterValues}
						handleFieldChange={handleFieldChange}
					/>
				))}
			</AccordionDetails>
		</Accordion>
	) : null;
};

export default FilterSectionAccordion;
